module.exports = __webpack_public_path__ + "static/img/eTower_white.697ff687.png";